__turbopack_context__.v({
  "bottomBar": "Footer-module-scss-module__A7Pepa__bottomBar",
  "copyright": "Footer-module-scss-module__A7Pepa__copyright",
  "footer": "Footer-module-scss-module__A7Pepa__footer",
  "formContainer": "Footer-module-scss-module__A7Pepa__formContainer",
  "headline": "Footer-module-scss-module__A7Pepa__headline",
  "inner": "Footer-module-scss-module__A7Pepa__inner",
  "left": "Footer-module-scss-module__A7Pepa__left",
  "legalLink": "Footer-module-scss-module__A7Pepa__legalLink",
  "legalLinks": "Footer-module-scss-module__A7Pepa__legalLinks",
  "logoLink": "Footer-module-scss-module__A7Pepa__logoLink",
  "marketingCopy": "Footer-module-scss-module__A7Pepa__marketingCopy",
  "navItem": "Footer-module-scss-module__A7Pepa__navItem",
  "navLink": "Footer-module-scss-module__A7Pepa__navLink",
  "navLinks": "Footer-module-scss-module__A7Pepa__navLinks",
  "navSocialGrid": "Footer-module-scss-module__A7Pepa__navSocialGrid",
  "right": "Footer-module-scss-module__A7Pepa__right",
  "socialItem": "Footer-module-scss-module__A7Pepa__socialItem",
  "socialLink": "Footer-module-scss-module__A7Pepa__socialLink",
  "socialLinkText": "Footer-module-scss-module__A7Pepa__socialLinkText",
  "socialLinks": "Footer-module-scss-module__A7Pepa__socialLinks",
  "stack-module-0": "Footer-module-scss-module__A7Pepa__stack-module-0",
  "stack-module-1": "Footer-module-scss-module__A7Pepa__stack-module-1",
  "stack-module-10": "Footer-module-scss-module__A7Pepa__stack-module-10",
  "stack-module-11": "Footer-module-scss-module__A7Pepa__stack-module-11",
  "stack-module-12": "Footer-module-scss-module__A7Pepa__stack-module-12",
  "stack-module-13": "Footer-module-scss-module__A7Pepa__stack-module-13",
  "stack-module-14": "Footer-module-scss-module__A7Pepa__stack-module-14",
  "stack-module-15": "Footer-module-scss-module__A7Pepa__stack-module-15",
  "stack-module-16": "Footer-module-scss-module__A7Pepa__stack-module-16",
  "stack-module-17": "Footer-module-scss-module__A7Pepa__stack-module-17",
  "stack-module-18": "Footer-module-scss-module__A7Pepa__stack-module-18",
  "stack-module-19": "Footer-module-scss-module__A7Pepa__stack-module-19",
  "stack-module-2": "Footer-module-scss-module__A7Pepa__stack-module-2",
  "stack-module-20": "Footer-module-scss-module__A7Pepa__stack-module-20",
  "stack-module-3": "Footer-module-scss-module__A7Pepa__stack-module-3",
  "stack-module-4": "Footer-module-scss-module__A7Pepa__stack-module-4",
  "stack-module-5": "Footer-module-scss-module__A7Pepa__stack-module-5",
  "stack-module-6": "Footer-module-scss-module__A7Pepa__stack-module-6",
  "stack-module-7": "Footer-module-scss-module__A7Pepa__stack-module-7",
  "stack-module-8": "Footer-module-scss-module__A7Pepa__stack-module-8",
  "stack-module-9": "Footer-module-scss-module__A7Pepa__stack-module-9",
  "subheadline": "Footer-module-scss-module__A7Pepa__subheadline",
  "z-base": "Footer-module-scss-module__A7Pepa__z-base",
  "z-content": "Footer-module-scss-module__A7Pepa__z-content",
  "z-footer": "Footer-module-scss-module__A7Pepa__z-footer",
  "z-header": "Footer-module-scss-module__A7Pepa__z-header",
  "z-hero": "Footer-module-scss-module__A7Pepa__z-hero",
  "z-logo": "Footer-module-scss-module__A7Pepa__z-logo",
  "z-logo-effect": "Footer-module-scss-module__A7Pepa__z-logo-effect",
  "z-navigation": "Footer-module-scss-module__A7Pepa__z-navigation",
  "z-sub": "Footer-module-scss-module__A7Pepa__z-sub",
});
